export const getUserStatus = state => state.login.isUserRegistered;
